import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import {getMySupplyList, mySupplyTopping, refreshSupply, supplyUpperAndLower, delMySupply, getWechatAppUrl} from '@/api/miscellaneous';
import {Toast, Dialog} from 'vant';
import moment from 'moment';
import {turnPages} from '@/hooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'MySupplyList',
  setup(__props, { expose }) {
  expose();

const getListData = ref({
    // page: 1,
    categoryId: '',
});
// const list = ref<any[]>([]);
// const loading = ref(false);
// const finished = ref(false);
const {
    list,
    loading,
    finished,
    loadMore: getList,
} = turnPages({
    api: getMySupplyList,
    params: getListData,
    loadingReturn: true,
});

// const getList = async () => {
//     loading.value = true;
//     const res: any = await getMySupplyList(getListData.value);
//     list.value = list.value.concat(res.items);
//     loading.value = false;
//     finished.value = getListData.value.page * getListData.value.size >= res.totalCount;
//     getListData.value.page++;
// };
getList();

const topping = (item: any) => {
    const {id, upper} = item;
    mySupplyTopping({id, upper}).then(res => {
        item.upper = !item.upper;
        Toast.success('置顶成功');
    });
};

const refresh = (item: any) => {
    const {id} = item;
    refreshSupply({id}).then(res => {
        item.refreshTime = moment().format('YYYY-MM-DD HH:mm:ss');
        Toast.success('刷新成功');
    });
};

const upperAndLower = (item: any) => {
    const {id, online} = item;
    supplyUpperAndLower({id, online}).then(res => {
        item.online = !item.online;
        Toast.success('操作成功');
    });
};

const del = (id: string, idx: number) => {
    Dialog.confirm({
        title: '提示',
        message: '确定删除该供应吗？',
        confirmButtonColor: 'red',
    }).then(() => {
        delMySupply({id}).then(res => {
            list.value.splice(idx, 1);
            Toast.success('删除成功');
        });
    });
};

const toUpper = () => {
    getWechatAppUrl({url: 'packageA/pages/zhiding/zhiding', query: 'isSingle=1&vipfrom=supply_list'}).then(res => {
        location.href = JSON.parse(res).openlink;
    });
};

const __returned__ = { getListData, list, loading, finished, getList, topping, refresh, upperAndLower, del, toUpper, ref, getMySupplyList, mySupplyTopping, refreshSupply, supplyUpperAndLower, delMySupply, getWechatAppUrl, Toast, Dialog, moment, turnPages }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})